import { render, staticRenderFns } from "./TypeLookUp.vue?vue&type=template&id=3b4164d1&scoped=true"
import script from "./TypeLookUp.vue?vue&type=script&lang=js"
export * from "./TypeLookUp.vue?vue&type=script&lang=js"
import style0 from "./TypeLookUp.vue?vue&type=style&index=0&id=3b4164d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4164d1",
  null
  
)

export default component.exports